export var DASHBOARD_ROUTES = {
    defaultPath: "/disque100/denuncias",
    meusGraficos: "/meus-graficos",
    disque100: {
        denuncias: "/disque100/denuncias",
        vitimas: "/disque100/vitimas",
        violacoes: "/disque100/violacoes",
        outros: "/disque100/outros",
    },
    mulheres: {
        visaoGeral: "/mulheres/visao-geral",
        feminicidios: "/mulheres/feminicidios",
        perfilVitimas: "/mulheres/perfil-vitimas",
        tempoTerritorio: "/mulheres/tempo-territorio",
        bosDeams: "/mulheres/bos-deams",
    },
    lgbtqia: {
        year2022: "/lgbtqia/2022",
        year2023: "/lgbtqia/2023",
    },
};
export var DISQUE100_SUBTAB_TO_PATH = {
    denuncias: DASHBOARD_ROUTES.disque100.denuncias,
    vitimas: DASHBOARD_ROUTES.disque100.vitimas,
    violacoes: DASHBOARD_ROUTES.disque100.violacoes,
    outros: DASHBOARD_ROUTES.disque100.outros,
};
export var MULHERES_SUBTAB_TO_PATH = {
    "visao-geral": DASHBOARD_ROUTES.mulheres.visaoGeral,
    feminicidios: DASHBOARD_ROUTES.mulheres.feminicidios,
    "perfil-vitimas": DASHBOARD_ROUTES.mulheres.perfilVitimas,
    "tempo-territorio": DASHBOARD_ROUTES.mulheres.tempoTerritorio,
    "bos-deams": DASHBOARD_ROUTES.mulheres.bosDeams,
};
export var LGBTQIA_YEAR_TO_PATH = {
    "2022": DASHBOARD_ROUTES.lgbtqia.year2022,
    "2023": DASHBOARD_ROUTES.lgbtqia.year2023,
};
